export interface SystemApp {
  current_page: number;
  per_page: number;
  total_count: number;
  total_pages: number;
  forms: [];
}

export default async function fetchSystemApps(token): Promise<SystemApp> {
  const response = await fetch('/api/v2/forms/system_apps', {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'X-ApiToken': token },
  })
    .catch((error) => {
      throw new Error(error);
    });

  return response.json();
}

export async function fetchAccessibleForms(token): Promise<SystemApp> {
  const response = await fetch('/api/v2/forms', {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'X-ApiToken': token },
  })
    .catch((error) => {
      throw new Error(error);
    });
  return response.json();
}
